<h1 mat-dialog-title>
  <form [formGroup]="bookmarkForm" class="theme-light">
    <app-form-field label="Model Title">
      <input type="text" class="input input--large" formControlName="displayName" #displayName maxlength="60" placeholder="e.g. Human Heart">
    </app-form-field>
  </form>
</h1>

<mat-dialog-content>
  <div class="content theme-light">
    <!-- Chapter Browser -->
    <div class="content__chapters" *ngIf="chapters">
      <div
        class="content__chapter"
        [ngClass]="{'content__chapter--selected': chapter.id === selectedChapter.id}"
        (click)="handleChapterClick(chapter)"
        *ngFor="let chapter of chapters; let i = index">
        
        <!-- <div class="content__thumb" [ngStyle]="getImageStyle(chapter)"></div> -->
        
        <div class="content__index">
          {{ i + 1 }}.
        </div>

        <div class="content__title">
          {{ chapter.info.displayName || '-No Title-'}}
        </div>
      </div>
    </div>

    <!-- Editor -->
    <div class="content__editor">
      <form [formGroup]="chapterForm">
        <!-- Title -->
        <app-form-field label="Chapter Title">
          <input type="text" class="input w-100" formControlName="displayName" #displayName maxlength="60">
          <app-character-counter [field]="displayName"></app-character-counter>
        </app-form-field>

        <!-- Description -->
        <app-form-field label="Chapter Description">
          <textarea class="input w-100 input--nonresizable" rows="20" formControlName="description" #description maxlength="2000"></textarea>
          <app-character-counter [field]="description"></app-character-counter>
        </app-form-field>
      </form>
    </div>
  </div>
</mat-dialog-content>

<!-- actions -->
<mat-dialog-actions>
  <button app-button buttonType="flat" buttonTheme="light" [mat-dialog-close] type="button">Done</button>
</mat-dialog-actions>